export default {
    HOME: 'home',
    AUTO: 'auto',
    CONDO: 'condo',
    TENANT: 'tenant',
    LIFE: 'life',
    MOTO: 'moto',
};
